import PropTypes from 'prop-types';
import { HashLink } from 'react-router-hash-link';
import { useBoolean, useEventListener } from 'usehooks-ts';

import ColorButton from 'components/simple/ColorButton';
import { ButtonTopIcon } from 'assets/icons';

const styles = {
  button: ({ palette, breakpoints }) => ({
    position: 'fixed',
    bottom: 20,
    right: 20,
    backgroundColor: palette.info.main,
    color: palette.common.white,
    '&.MuiIconButton-root': {
      width: 40,
      height: 40,
      padding: 0.5,
    },
    [breakpoints.up('md')]: {
      bottom: 50,
      right: 50,
    },
  }),
};

const GoToTopButton = ({ hideButton = false }) => {
  const { value: showGoToTopButton, setValue: setShowGoToTopButton } = useBoolean();

  const scrollHandler = () => {
    setShowGoToTopButton(!hideButton && window.scrollY > window.innerHeight);
  };

  useEventListener('scroll', scrollHandler);

  if (!showGoToTopButton || hideButton) {
    return null;
  }

  return (
    <ColorButton
      component={HashLink}
      smooth
      to="#"
      icon={ButtonTopIcon}
      id="go-to-top-button"
      color="info"
      customStyles={styles.button}
    />
  );
};

GoToTopButton.propTypes = {
  hideButton: PropTypes.bool,
};
export default GoToTopButton;
